import React from "react";
import hiw1 from "../assets/hiw11.png";
import hiw2 from "../assets/hiw12.png";
import hiw3 from "../assets/hiw13.png";
import CallToAction from "./CallToAction";
function HowItWorks() {
    return (
        <div className="container how-it-works">
            <div >
                <h2 className="section-title" style={{padding:'2rem'}}>¿Cómo Funciona?</h2>

                <div className="hiw-step1 row">
                    <div className="col-md-6 text-center">
                        <img src={hiw1} alt ="Sim VR SimVR es un sistema de capacitación en Realidad Virtual que transforma la forma en que tu empresa entrena a empleados" className="hiwimage" />

                    </div>
                    <div className="col-md-6">
                        <p><b>SimVR</b> es un sistema de capacitación en <b>Realidad Virtual</b> que transforma la forma en que las empresas entrenan a sus empleados. En lugar de leer manuales, los trabajadores viven el proceso directamente a través de experiencias inmersivas en entornos virtuales. Está diseñado para apoyar áreas como Recursos Humanos, Formación, Entrenamiento, Innovación y Onboarding en empresas de todos los sectores.</p>

                    </div>
                    
                </div>

                <div className="hiw-step2 row">
                    <div className="col-md-6 text-center">
                        <img src={hiw2} alt="Nuestro objetivo es convertir la documentación tradicional basada en procesos (como las normas ICONTEC ISO 9001) en simulaciones reales en video 360. Estas experiencias permiten que tus empleados aprendan directamente de un expert" className="hiwimage" />

                    </div>
                    <div className="col-md-6">
                        <p>Nuestro objetivo es convertir la documentación tradicional basada en procesos (como las normas ICONTEC ISO 9001) en <b>simulaciones reales</b> en video 360. Estas experiencias permiten que los empleados aprendan directamente de un experto, quien les explica cada procedimiento dentro del entorno virtual donde realmente ocurre.</p>

                    </div>
                </div>
                <div className="hiw-step3 row">
                    <div className="col-md-6 text-center">
                        <img src={hiw3} alt="En sectores como el avícola en Colombia, hemos comprobado que el uso de SimVR" className="hiwimage" />

                    </div>
                    <div className="col-md-6">
                        <p>En sectores como el avícola en <b>Colombia</b>, hemos comprobado que el uso de <b>SimVR</b> no solo mejora la comprensión y retención del conocimiento, sino que también motiva a los nuevos empleados ingresar a una empresa innovadora. Esto se traduce en una mayor calidad en la ejecución de procesos y en un aumento en la tasa de vinculación de talento.</p>

                    </div>
                    
                    
                </div>
            </div>


        </div>

    );
}

export default HowItWorks;